<template>
  <div class="auth-wrapper auth-v1 d-flex align-center justify-center">
    <div class="auth-inner">
      <v-card class="auth-card pa-8 text-center">
        <v-card-text>
          <v-icon size="100" color="warning" class="mb-6">
            {{ icons.mdiAccountAlert }}
          </v-icon>

          <h2 class="text-h4 font-weight-bold mb-4">
            Academy Access Required
          </h2>

          <p class="text-body-1 mb-6">
            Your coach account is not currently associated with any academy. Please contact the P72 administrator to create an academy and assign your account to it.
          </p>

          <div class="d-flex flex-column gap-4">
            <v-btn
              color="primary"
              large
              :loading="isLoggingOut"
              @click="logout"
            >
              <v-icon left>
                {{ icons.mdiLogin }}
              </v-icon>
              Login Again
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <img
      class="auth-mask-bg"
      height="173"
      :src="require(`@/assets/images/misc/mask-${$vuetify.theme.dark ? 'dark':'light'}.png`)"
    >
  </div>
</template>

<script>
import { mdiAccountAlert, mdiLogin } from '@mdi/js'
import { ref } from 'vue'
import { useRouter } from '@/utils/index'
import useAuth from '@/composables/useAuth'

export default {
  setup() {
    const { router } = useRouter()
    const { logout: authLogout } = useAuth()
    const isLoggingOut = ref(false)

    const logout = async () => {
      isLoggingOut.value = true
      try {
        await authLogout()
        router.push({ name: 'login' })
      } catch (error) {
        console.error('Logout error:', error)
      } finally {
        isLoggingOut.value = false
      }
    }

    return {
      logout,
      isLoggingOut,
      icons: {
        mdiAccountAlert,
        mdiLogin,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@/plugins/vuetify/default-preset/preset/pages/auth.scss';

.gap-4 {
  gap: 1rem;
}
</style>
